﻿import { settings } from '../../../environments/environment';

export class DocumentPath {
    private static documentsPath = `/Content/Pdf`;
    static privacyStat = `${DocumentPath.documentsPath}/privacy_statements.pdf`;

}